import apiAxios from '@/apiAxios.js'
import { sysConfirm } from '@/ASysUtil/sysUtil.js'
import { sysPopSelectCompany } from '@/ASysUtil/sysUtil.js'

const moduleUrl = `/em/budgetRecord`

export default {
  components: {},
  props: {
    formId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      //调整余额
      balEditVisible: false,
      balEditItem: null,
      balItem: null,
      queryIsLoading: false,
      queryResult: {
        content: [],
      },
      queryParams: {
        companyId: '',
        companyName: '',
        limit: 50,
        page: 1,
        value: '',
        sort: '',
        orgIds: '',
        orgNames: '',
        code: '',
        expenseTypeName: '',
        expenseTypeIds: '',
        budgetPeriodIds: '',
        budgetPeriodNames: '',
        withNextLevelOrg: false,
        expenseTypeLevel: '',

        initAmountStart: '',
        initAmountEnd: '',
        adjustAmountStart: '',
        adjustAmountEnd: '',
        rollingAmountStart: '',
        rollingAmountEnd: '',
        rollingSubAmountStart: '',
        rollingSubAmountEnd: '',
        usedAmountStart: '',
        usedAmountEnd: '',
        budgetControlStrategy: '',
        budgetControl: null,
      },
      moreQueryOpened: false,

      // 余额详情
      balDetailVisible: false,
      detailIsLoading: false,
      detailId: '',
      expenseTypeLevelList: [],
      detailResult: {
        content: [],
      },
      popTitle: null,
      detailParams: {
        limit: 50,
        page: 1,
        sort: '',
        changeType: '',
        value: '',
      },
    }
  },
  watch: {},
  computed: {},
  methods: {
    async volumeBudgetRolling() {
      // 批量预算滚动公司选择
      let idList = []
      await sysPopSelectCompany({
        url: '/base/company/userAuthorityCompany',
        multi: true,
        processQueryParams: params => {
          params.sort = 'code,asc'
        },
        onChoose: choosedList => {
          idList = choosedList.map(vv1 => vv1.id)
          if (!idList.length) return this.$message.info(`请选择至少一个公司!`)
          this.setBudgetRolling(idList)
        },
      })
    },
    async setBudgetRolling(ids) {
      // 设置批量预算滚动
      const { data } = await apiAxios.post(
        `/em/budgetRecord/rollBudgetRecord`,
        ids
      )
      this.$message.success(data.message)
    },
    toggleMoreQuery() {
      if (this.moreQueryOpened) {
        this.moreQueryOpened = false
        Object.assign(this.queryParams, {
          initAmountStart: '',
          initAmountEnd: '',
          adjustAmountStart: '',
          adjustAmountEnd: '',
          rollingAmountStart: '',
          rollingAmountEnd: '',
          rollingSubAmountStart: '',
          rollingSubAmountEnd: '',
          usedAmountStart: '',
          usedAmountEnd: '',
          budgetControlStrategy: '',
          budgetControl: null,
        })
      } else {
        this.moreQueryOpened = true
      }
    },
    // 取消编辑余额
    cancelEditBal() {
      this.balEditItem = null
      this.balEditVisible = false
    },
    // 编辑余额
    handleEditBal(item) {
      this.balItem = Object.assign({}, item)
      this.balEditItem = {
        adjustAmount: '',
        clear: false,
        recordId: item.id,
        remarks: null,
      }
      this.balEditVisible = true
    },
    // 保存调整余额
    async saveBalEdit() {
      const putParams = [this.balEditItem]
      const { data } = await apiAxios.put(`${moduleUrl}/adjust`, putParams)
      this.$message.success(data.message)
      this.balEditVisible = false
      await this.loadData()
    },

    //查询余额详情
    async balanceDetail(item, type, title) {
      if (item) {
        this.detailId = item.id
        this.detailParams.changeType = type // 0-本期调整金额；1-滚动增加金额；2-当期发生金额；3-滚动减少金额
      }
      this.popTitle = title
      await this.getDetailResult()
    },
    async getDetailResult() {
      this.balDetailVisible = true
      this.detailIsLoading = true
      this.detailResult = {}
      const serverQueryParams = Object.assign({}, this.detailParams)
      serverQueryParams.page -= 1 // 服务器从0开始计数
      const { data } = await apiAxios.get(
        `${moduleUrl}/${this.detailId}/changeLog`,
        {
          params: serverQueryParams,
        }
      )
      data.result.content.forEach(vv1 => {
        vv1.refId = vv1.refId.substring(0, vv1.refId.indexOf('#'))
      })
      this.detailResult = data.result
      this.detailIsLoading = false
    },

    //启动确认
    async enabledEven(item) {
      this.$confirm('您确定要启动预算吗?(此操作不可逆)', '启动确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'danger',
      }).then(
        async () => {
          const { id } = item
          const putParams = {
            boolValue: true,
            budgetRecordIds: [id],
          }
          const { data } = await apiAxios.put(
            `/em/budgetRecord/enable`,
            putParams
          )
          this.$message.success(data.message)
          await this.loadData()
        },
        function onCancel() {}
      )
    },
    // 公共 滚动 冻结
    async handleEven(item, state, urlType) {
      let title = ''
      let descript = ''
      //- TODO 暂注释掉
      // if (urlType == 'public') {
      //   //设置 是否公共
      //   title = !state ? '您确定要设为公共费用' : '您确定要取消公共费用'
      //   descript = '公共费用确认'
      // }
      if (urlType == 'rolling') {
        //设置 滚动
        title = !state ? '您确定要设为滚动' : '您确定要取消滚动'
        descript = '滚动确认'
      }
      if (urlType == 'frozen') {
        //设置 冻结
        title = !state ? '您确定要设为冻结' : '您确定要取消冻结'
        descript = '冻结确认'
      }

      this.$confirm(title, descript, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'danger',
      }).then(
        async () => {
          const { id } = item
          const putParams = {
            boolValue: !state,
            budgetRecordIds: [id],
          }
          const { data } = await apiAxios.put(
            `${moduleUrl}/${urlType}`,
            putParams
          )
          this.$message.success(data.message)
          await this.loadData()
        },
        function onCancel() {}
      )
    },

    // 预算期间
    filterBudgetPeriodType(param) {
      if (this.queryParams.budgetYear) {
        param.budgetYear = parseInt(this.queryParams.budgetYear)
      }
    },
    processChooseBudgetPeriod(chooseList) {
      if (chooseList.length) {
        this.queryParams.budgetPeriodIds = chooseList[0].id
        this.queryParams.budgetPeriodNames = chooseList[0].name
      } else {
        this.queryParams.budgetPeriodIds = ''
        this.queryParams.budgetPeriodNames = ''
      }
      this.loadData()
    },

    async ReLoadData() {
      this.queryParams.page = 1
      await this.loadData()
    },
    async loadData() {
      this.queryIsLoading = true
      this.queryResult = {}
      const serverQueryParams = Object.assign({}, this.queryParams)
      serverQueryParams.page -= 1 // 服务器从0开始计数
      if (!this.queryParams.expenseTypeLevel) {
        serverQueryParams.expenseTypeLevel = 0
      }
      const { data } = await apiAxios.get(`${moduleUrl}`, {
        params: serverQueryParams,
      })
      this.queryIsLoading = false
      this.queryResult = data.result
      //console.log(this.queryResult)
    },

    changeCompany() {
      this.queryParams.orgIds = ''
      this.queryParams.orgNames = ''
      this.loadData()
    },
    async BudgetSummaryForExpenseType() {
      const { formId } = this
      const { orgIds } = this.queryParams
      if (orgIds) {
        const { data } = await apiAxios.post(
          `/em/budgetRecord/summaryForExpenseType/byOrgId/${orgIds}/formId/${formId}`
        )
        this.$message.success(data.result)
      } else {
        this.$message.error('请选择组织机构！')
      }
    },
    async BudgetSummaryForOrg() {
      const { formId } = this
      const { companyId } = this.queryParams
      if (companyId) {
        const { data } = await apiAxios.post(`/em/budgetRecord/summaryForOrg`, {
          companyId: companyId,
          formId: formId,
          expenseTypeId: this.queryParams.expenseTypeIds,
        })
        this.$message.success(data.result)
      } else {
        this.$message.error('请选择公司！')
      }
    },
    async batchOpt(batchStatus, msg) {
      if (
        !(await sysConfirm(
          `您确定批量${msg}以下 ${
            this.queryResult.totalElements ? this.queryResult.totalElements : 0
          } 条预算记录吗?`,
          `批量${msg}预算记录`
        ))
      ) {
        return false
      }
      this.queryIsLoading = true
      const serverQueryParams = Object.assign({}, this.queryParams)
      this.$set(serverQueryParams, 'batchStatus', batchStatus)
      if (!this.queryParams.expenseTypeLevel) {
        serverQueryParams.expenseTypeLevel = 0
      }
      const { data } = await apiAxios.get(
        `/em/budgetRecord/batchChangeStatus`,
        {
          params: serverQueryParams,
        }
      )
      this.$message.success(data.result)
      this.queryIsLoading = false
      await this.loadData()
    },
    async BatchDelAll() {
      if (await sysConfirm(`您确定批量删除预算记录吗?`, `批量删除预算记录`)) {
        const serverQueryParams = Object.assign({}, this.queryParams)
        const { data } = await apiAxios.delete(`/em/budgetRecord/batch`, {
          params: serverQueryParams,
        })
        this.$message.success(data.message)
        await this.loadData()
      }
    },
    async DelOne(row, index) {
      if (await sysConfirm(`您确定删除预算记录吗?`, `删除预算记录`)) {
        const { data } = await apiAxios.delete(`/em/budgetRecord/${row.id}`)
        this.$message.success(data.message)
        this.queryResult.content.splice(index, 1)
        this.queryResult.totalElements = this.queryResult.content.length
      }
    },
    async getExpenseTypeLevelList() {
      const { data } = await apiAxios.get(`em/expenseType/maxLevel`)
      if (data.result > 0) {
        for (let i = 1; i <= data.result; i++) {
          this.expenseTypeLevelList.push({
            key: i,
            value: i + '级',
          })
        }
      }
    },
  },
  async mounted() {
    this.getExpenseTypeLevelList()
  },
}
